import { attackToDisplayName } from 'src/app/common/violationRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const AttackSelectOptionAll: ISelectOption = {
  id: `${FilterTypesEnum.Attack.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.Attack,
  categoryName: FilterTypesEnum.Attack.toString(),
};

export const AttackSelectOptions: ISelectOption[] = Object.keys(attackToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.Attack.toString()}-${attackKey}`,
      value: attackKey,
      displayName: attackToDisplayName[attackKey],
      filterType: FilterTypesEnum.Attack,
      categoryName: FilterTypesEnum.Attack.toString(),
    }) as ISelectOption
);
